"use strict";
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.standardise = exports.formatDegreesMinutesSeconds = exports.convert = void 0;
var conversion_1 = require("./conversion");
Object.defineProperty(exports, "convert", { enumerable: true, get: function () { return conversion_1.convert; } });
Object.defineProperty(exports, "formatDegreesMinutesSeconds", { enumerable: true, get: function () { return conversion_1.formatDegreesMinutesSeconds; } });
/** Convert a measurement unit to its conventional form */
const standardise = (raw) => {
    if (!raw)
        return "";
    // Remember to keep all case strings lower-case!
    switch (raw.toLowerCase().trim()) {
        case "dimensionless":
        case "unit":
            return "";
        case "Bar":
            return "bar";
        case "degrees":
        case "degree":
        case "deg":
        case "degreesdecimal":
        case "degreedecimal":
        case "º": // "masculine ordinal" symbol
            return "°";
        case "centigrade":
        case "degreecentigrade":
        case "degreescentigrade":
        case "celsius":
        case "degreecelsius":
        case "degreescelsius":
        case "degreec":
        case "degreesc":
        case "ºc": // "masculine ordinal" symbol
        case "℃": // single character (poor font support)
            return "°C";
        case "fahrenheit":
        case "farenheit": // thanks Dave
        case "degreefahrenheit":
        case "degreesfahrenheit":
        case "degreef":
        case "degreesf":
        case "ºf": // "masculine ordinal" symbol
        case "℉": // single character (poor font support)
            return "°F";
        case "kelvin":
        case "degreekelvin":
        case "degreeskelvin":
        case "°k":
        case "ºk": // "masculine ordinal" symbol
        case "K": // Kelvin sign (poor font support)
            return "K";
        case "metre":
        case "meter":
        case "metres":
        case "meters":
            return "m";
        case "millimetre":
        case "millimeter":
        case "millimetres":
        case "millimeters":
        case "m-3":
            return "mm";
        case "micrometre":
        case "micrometer":
        case "micrometres":
        case "micrometers":
        case "micron":
        case "microns":
        case "m-6":
        case "um":
        case "μm": // Greek letter mu, a different character to the micro symbol
            return "µm";
        case "inch":
        case "inches":
        case "″": // double prime, which can indicate inches or seconds
        case '"': // double quote, sometimes used as a substitute for double prime
            return "in";
        case "microinch":
        case "micro-inch":
        case "microinches":
        case "micro-inches":
        case "in-6":
        case "uin":
        case "μin": // Greek letter mu, a different character to the micro symbol
            return "µin";
        case "mill":
        case "thou":
        case "in-3":
            return "min"; // milliinches 0~0
        case "foot":
        case "feet":
        case "′": // prime, which can indicate feet or minutes
        case "'": // single quote, used as a substitute for prime
            return "ft";
        case "gram":
        case "gramme":
            return "g";
        case "kilo":
        case "kilogram":
        case "kilogramme":
            return "kg";
        case "pound":
        case "lbs":
        case "#":
            return "lb";
        case "10-6c-1": // Coefficient of thermal expansion
        case "10-6/°c":
        case "10-6/ºc":
        case "10-6/c":
            return "×10⁻⁶/°C";
        case "pascal":
        case "pa":
        case "pascals":
        case "kg.m/s2":
        case "kg.m/s²":
            return "Pa";
        case "hpa": // A hectopascal is the same as a millibar
        case "millibar":
        case "bar-3":
        case "mBar":
            return "mbar";
        case "psi":
        case "lb/in2":
        case "lb/in²":
            return "psi";
        case "g/l": // A gram per litre is a kilogram per cubic metre
        case "kg/m3":
        case "kgm3":
            return "kg/m³";
        case "mg/l": // A milligram per litre is a gram per cubic metre
        case "g/m3":
        case "gm3":
            return "g/m³";
        case "lbs/ft3":
        case "lb/ft3":
        case "lbsft3":
        case "lbs/ft³": // I'm sure there are even more cursed ways to write this; keep an eye out
            return "lb/ft³";
        case "mm/s1":
            return "mm/s";
        case "mm/s2":
            return "mm/s²";
        case "m/s2":
            return "m/s²";
        case "ft/s2":
            return "ft/s²";
        case "in/s2":
            return "in/s²";
        case "permille":
        case "promille":
            return "‰";
        case "umol/mol":
        case "μmol/mol": // Greek letter mu, a different character to the micro symbol
            return "µmol/mol";
        case "l": // Both l and L are officially recognised; use capital L for legibility
        case "litre":
        case "liter":
        case "litres":
        case "liters":
            return "L";
        case "ml/min":
        case "ml/minute":
            return "mL/min";
        case "l/min":
        case "l/minute":
            return "L/min";
        case "m3/s":
        case "m^3/s":
            return "m³/s"; // Flow in cubic metres per second
        case "m3/min":
        case "m^3/min":
            return "m³/min"; // Flow in cubic metres per minute
        case "m3/hr":
        case "m^3/hr":
            return "m³/hr"; // Flow in cubic metres per hour
        case "hz":
        case "cps": // cycles per second
        case "c/s":
            return "Hz";
        case "volt":
        case "volts":
            return "V";
        case "amp":
        case "amps":
        case "ampere":
        case "amperes":
            return "A";
        default:
            return raw;
    }
};
exports.standardise = standardise;
//# sourceMappingURL=index.js.map